export default __webpack_public_path__ + "static/media/upper_view.a269385b.png";